import React, { useState } from 'react';
import { Order } from '@restaurant/api';
import { PAYMENT_METHOD_TEXT } from '@restaurant/constants';
import { OrderType } from '@restaurant/types';
import { formatCurrency } from '@restaurant/utils';
import { Button } from 'antd';
import { formatDateTime } from '~/utils/date';

const PaymentHistory = ({ order }: { order: Order }) => {
  const [isExpand, setIsExpand] = useState(false);

  if (order.orderType !== OrderType.Indent) {
    return null;
  }

  if (!order.payment?.details?.length) {
    return <div className="p-4">Belum ada pembayaran</div>;
  }

  const outstandingPayment =
    order.totalPrice -
    (order.payment.totalAmount + order.payment.roundingAmount);

  return (
    <div className="p-4 flex flex-col gap-1 bg-white">
      <div className="flex justify-between items-center">
        <p>Rounding</p>
        <p>{formatCurrency(order.payment.roundingAmount)}</p>
      </div>
      <div>
        <div className="flex justify-between items-center">
          <div className="flex gap-2">
            <p className="text-lg font-semibold">Pembayaran</p>
            <Button
              type="link"
              className="px-0"
              onClick={() => setIsExpand((val) => !val)}
            >
              {isExpand ? 'Hide' : 'Show'}
            </Button>
          </div>
          <p>{formatCurrency(order.payment?.totalAmount ?? 0)}</p>
        </div>
        {isExpand &&
          order.payment?.details?.map((item, index) => (
            <div className="flex justify-between items-center">
              <div>
                <p>
                  #{index + 1} {PAYMENT_METHOD_TEXT[item.method]}
                </p>
                <p className="text-[10px]">{formatDateTime(item.timestamp)}</p>
              </div>
              <p>{formatCurrency(item.amount)}</p>
            </div>
          ))}
      </div>
      <div className="flex justify-between items-center">
        <p className="text-lg font-semibold">Sisa Tagihan</p>
        <p>{formatCurrency(outstandingPayment)}</p>
      </div>
    </div>
  );
};

export default PaymentHistory;
